export const CLEAR_ACTION = "CLEAR_ACTION"

export const PATCH_ACTION = "PATCH_ACTION"
export const PATCH_ACTION_FAIL = "PATCH_ACTION_FAIL"

export const DELETE_ACTION = "DELETE_ACTION"
export const DELETE_ACTION_FAIL = "DELETE_ACTION_FAIL"

export const POST_ACTION = "POST_ACTION"
export const POST_ACTION_FAIL = "POST_ACTION_FAIL"

export const GET_ACTION = "GET_ACTION"
export const FETCH_ACTION_FAIL = "FETCH_ACTION_FAIL"
export const SET_FAIL_MESSAGE = "SET_FAIL_MESSAGE"


export const GET_ALL_ACTIONS = 'GET_ALL_ACTIONS'
export const GET_ALL_ACTIONS_FAIL = 'GET_ALL_ACTIONS_FAIL'

export const CLEAR_OKR_ACTION = "CLEAR_OKR_ACTION"

export const PATCH_OKR_ACTION = "PATCH_OKR_ACTION"
export const PATCH_OKR_ACTION_FAIL = "PATCH_OKR_ACTION_FAIL"

export const DELETE_OKR_ACTION = "DELETE_OKR_ACTION"
export const DELETE_OKR_ACTION_FAIL = "DELETE_OKR_ACTION_FAIL"

export const POST_OKR_ACTION = "POST_OKR_ACTION"
export const POST_OKR_ACTION_FAIL = "POST_OKR_ACTION_FAIL"

export const GET_OKR_ACTION = "GET_OKR_ACTION"

export const FETCH_OKR_ACTION_FAIL = "FETCH_OKR_ACTION_FAIL"

export const SET_OKR_FAIL_MESSAGE = "SET_OKR_FAIL_MESSAGE"

export const GET_ALL_OKR_ACTIONS = 'GET_ALL_OKR_ACTIONS'
export const GET_ALL_OKR_ACTIONS_FAIL = 'GET_ALL_OKR_ACTIONS_FAIL'